import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

import {
	FCM_EXPERIMENT_DASHBOARD_TABS,
	FCM_EXPERIMENT_HELLO_WORLD,
	FCM_EXPERIMENT_STARTER_EXPERIENCE_GROUP_RECS_NEW_DESIGN,
	FCM_EXPERIMENT_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS_V03,
} from './config';

export const {
	FcmExperimentsContext: StarterDashboardPageFcmExperimentsContext,
	FcmExperimentsProvider: StarterDashboardPageFcmExperimentsContextProvider,
	useFcmExperiments: useStarterDashboardPageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStarterDashboardPageFcmExperiments,
	prefetchFcmExperiments: prefetchStarterDashboardPageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StarterDashboardPageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		helloExperiment: FCM_EXPERIMENT_HELLO_WORLD,
		dashboardTabsExperiment: FCM_EXPERIMENT_DASHBOARD_TABS,
		shareRecommendationsExperiment: FCM_EXPERIMENT_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS_V03,
		groupRecsNewDesignExperiment: FCM_EXPERIMENT_STARTER_EXPERIENCE_GROUP_RECS_NEW_DESIGN,
	},
	prefetch: true,
});

export type StarterDashboardPageFcmExperimentsState = ReturnType<typeof useAsyncStarterDashboardPageFcmExperiments>;
export type StarterDashboardPageFcmExperiments = LoadedStateData<StarterDashboardPageFcmExperimentsState>;
